import { css, StyleSheet } from 'aphrodite';
import React from 'react';


export default function App() {
  
  const styles = StyleSheet.create({
    about: {
      width: '100%',
      height: 'auto',
      backgroundColor: '#E7421C', //rgba(15, 20, 36, 1)
      color: 'white',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      '@media (max-width: 600px)': {
        textAlign: 'center',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }
    },
    highlightBox: {
      padding: '3em 1em 3em 3em',
      width: '100%',
      flex: 2,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      verticalAlign: "middle",
      '@media (max-width: 600px)': {
        padding: "1em 1em 1em 1em",
        flexDirection: "row",
        justifyContent: "flex-start",
      }
    },
    highlight: {
      listStylePosition: "inside",
      padding: "0.2em",
      '@media (max-width: 600px)': {
        padding: "Opx",
        textAlign: "start"
      }
    }, 
    info: {
      padding: '3em 3em 3em 3em',
      width: '100%',
      flex: 3,
      backgroundColor: 'white',
      color: 'rgba(15, 20, 36, 1)',
      textAlign: "start",
      '@media (max-width: 600px)': {
        textAlign: "justify"
      }
    }
  });


  return (
    <div className={css(styles.about)}>
        <div className={css(styles.highlightBox)}>
          <ul>
            <li><h4 className={css(styles.highlight)} style={{paddingTop: 0}}>Úspěšně již 23 let na stavebním trhu</h4></li>
            <li><h4 className={css(styles.highlight)} style={{paddingTop: 0}}>Zavedená, perspektivní firma s dobrým jménem</h4></li>
            <li><h4 className={css(styles.highlight)}>Kvalita prací a plnění termínů jsou samozřejmostí</h4></li>
            <li><h4 className={css(styles.highlight)}>Odbourání mezičlánku – firma disponuje řadou kvalitních kmenových zaměstnanců </h4></li>
            <li><h4 className={css(styles.highlight)}>Flexibilní a okamžité řešení technických i administrativních problémů</h4></li>
            <li><h4 className={css(styles.highlight)}>Na provedené práce poskytujeme záruku až 60 měsíců.</h4></li>
          </ul>
        </div>
        <div className={css(styles.info)}>
         <h3>O společnosti</h3>
          <p>Společnost Elmida s.r.o. aktivní na českém trhu od roku 1998, která nabízí veškerou škálu stavebních a technických prací od zpracování projektu až po předání stavby spokojenému investorovi.</p>
          <p>Firma disponuje zkušenostmi ze staveb jak malého, tak velkého rozsahu, kde je nutná důslednost, spolupráce, kvalita a čas pro výstavbu. Ani práce ve velkých provozech nám není cizí.</p>
          <p>Již řadu let realizujeme státní zakázky, na které je kladena vysoká profesionalita, preciznost a finanční stabilita firmy.</p>
          <p>Klademe důraz na férové jednání a garantujeme dokončení zakázek v požadované kvalitě a dohodnutých cenách i termínech.</p>
          <p>Veškeré činnosti v oblasti provádění pozemních staveb a dodávání stavebních prací, včetně montáží ocelových konstrukcí, jsou ve shodě se systémem managementu jakosti s normou ČSN EN 9001:2001.</p>
          <p>Nejdůležitější je Vaše konečná spokojenost. Budeme rádi, když se se svými plány obrátíte na nás a společně je dovedeme k dokonalosti.</p>
        </div>
    </div>
  );
}
